import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import StockPic from "../assets/images/raster/components/Seo/stock_one_img.jpg";
import FontRegular from "../assets/scss/fonts/MontserratFonts/montserrat-v15-latin-500.woff2";
import FontBold from "../assets/scss/fonts/MontserratFonts/montserrat-v15-latin-700.woff2";

function Seo({
  description = ``,
  lang = `en`,
  meta = [],
  metaTitle,
  title,
  page = "",
  manifest,
  ogImg = "",
  keywords,
  bodyClassName = "",
  trustpilotWidget,
  disableLoader,
}) {
  const metaDescription = description;

  return (
    <Helmet
      bodyAttributes={bodyClassName.length > 0 ? { class: bodyClassName } : {}}
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          charset: "utf-8",
        },
        {
          name: `viewport`,
          content:
            "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0",
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle ?? title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:url`,
          content: `${process.env.HOST}/${page}`,
        },
        {
          property: `og:locale`,
          content: `en_US`,
        },
        {
          property: `og:image`,
          content: `${process.env.HOST}${ogImg}`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:site_name`,
          content: `AMZScout`,
        },
        {
          name: `twitter:site`,
          content: `@AmzScout`,
        },
        {
          name: `twitter:card`,
          content: `${ogImg}`,
        },
        {
          name: `twitter:title`,
          content: metaTitle ?? title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `msapplication-TileColor`,
          content: "#da532c",
        },
        {
          name: `msapplication-TileImage`,
          content: "/favicon/mstile-144x144.png?v=7",
        },
        {
          name: `msapplication-config`,
          content: `/favicon/${manifest}?v=7`,
        },
        {
          name: `twitter:image`,
          content: "/img/new/twitterc.svg",
        },
        {
          name: `theme-color`,
          content: "#fff",
        },
      ]
        .concat(
          keywords !== undefined
            ? keywords.length > 0
              ? {
                  name: `keywords`,
                  content: keywords.join(`, `),
                }
              : []
            : []
        )
        .concat(meta)}
      link={[
        {
          rel: "preload",
          as: "font",
          type: "font/woff2",
          crossOrigin: "anonymous",
          href: FontRegular,
        },
        {
          rel: "preload",
          as: "font",
          type: "font/woff2",
          crossOrigin: "anonymous",
          href: FontBold,
        },
        {
          rel: "chrome-webstore-item",
          href: "https://chrome.google.com/webstore/detail/jjddacdiaghmhplanidommpeehflcphk",
        },
        {
          rel: "chrome-webstore-item",
          href: `${process.env.SCOUT_EXT_PRO}`,
        },
        { rel: "apple-touch-icon", href: "/favicon/apple-touch-icon.png?v=7" },
        {
          rel: "apple-touch-icon-precomposed",
          href: "/favicon/apple-touch-icon-precomposed.png?v=7",
        },
        {
          rel: "icon",
          href: "/favicon/favicon-32x32.png?v=7",
          type: "image/png",
          sizes: "32x32",
        },
        {
          rel: "icon",
          href: "/favicon/favicon-16x16.png?v=7",
          type: "image/png",
          sizes: "16x16",
        },
        { rel: "manifest", href: `/manifest.webmanifest` },
        {
          rel: "mask-icon",
          href: "/favicon/safari-pinned-tab.svg?v=7",
          color: "#ff8e12",
        },
        { rel: "shortcut icon", href: "/favicon/favicon.ico?v=7" },
        { rel: "canonical", href: `${process.env.HOST}${page && "/" + page}/` },
      ]}
    >
      {/* Anti-flickering script */}
      {!disableLoader ? (
        <script>
          {`
            !function(){
              const t=2e3,d=document,w=window,s=d.createElement("style");
              s.id="gpl-style",s.textContent='#___gatsby{opacity:0}',d.head.appendChild(s);
              const l=d.createElement("div");
              l.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 128 128" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:9999"><g><circle cx="16" cy="64" r="5.375" fill="#ffa23c"/><circle cx="16" cy="64" r="6.438" fill="#ffa23c" transform="rotate(45 64 64)"/><circle cx="16" cy="64" r="8.063" fill="#ffa23c" transform="rotate(90 64 64)"/><circle cx="16" cy="64" r="10.063" fill="#ffa23c" transform="rotate(135 64 64)"/><circle cx="16" cy="64" r="10.75" fill="#ffa23c" transform="rotate(180 64 64)"/><circle cx="16" cy="64" r="12.531" fill="#ffa23c" transform="rotate(225 64 64)"/><circle cx="16" cy="64" r="14.344" fill="#ffa23c" transform="rotate(270 64 64)"/><circle cx="16" cy="64" r="16" fill="#ffa23c" transform="rotate(315 64 64)"/><animateTransform attributeName="transform" type="rotate" values="0 64 64;45 64 64;90 64 64;135 64 64;180 64 64;225 64 64;270 64 64;315 64 64" calcMode="discrete" dur="720ms" repeatCount="indefinite"/></g></svg>';
              d.body.appendChild(l);
              function r(){
                if(!w.gpl)return;
                const e=d.getElementById("gpl-style"),n=l.parentNode===d.body?l:0;
                e&&d.head.removeChild(e),n&&d.body.removeChild(n);
                const o=d.getElementById("___gatsby");
                o&&(o.style.opacity=1),w.gpl=0
              }
              w.gpl=r;
              const c=setInterval(()=>{
                const e=d.getElementById("___gatsby");
                e&&e.children.length&&(clearInterval(c),setTimeout(()=>w.requestAnimationFrame(r),200))
              },100);
              setTimeout(()=>{
                clearInterval(c),w.requestAnimationFrame(r)
              },t)
            }();
        `}
        </script>
      ) : null}

      {/* Mida A/B Testing Script */}
      <script
        type="text/javascript"
        async
        src="https://cdn.mida.so/js/optimize.js?key=ryMZOEQ6R2EZrYljzpgDW7"
      ></script>

      {/* start Mindbox Script */}

      <script>
        {`
          maestra = window.maestra || function() { maestra.queue.push(arguments); };
          maestra.queue = maestra.queue || [];
          maestra('create', {endpointId: 'AMZScout'});
        `}
      </script>

      <script src="https://api.maestra.io/scripts/v1/tracker.js" async></script>

      {/* end Mindbox Script */}

      <script type="application/ld+json">{`
        {
          "@context": "http://schema.org",
          "@id": "https://amzscout.net/#organization",
          "@type": "Organization",
          "name": "AMZScout",
          "url": "https://amzscout.net",
          "logo": "/img/new/logo.png",
          "contactPoint": [{
            "@type": "ContactPoint",
            "telephone": "+12513456772",
            "contactType": "sales",
            "areaServed": "US"
          }, {
            "@type": "ContactPoint",
            "telephone": "+12513456772",
            "contactType": "technical support",
            "areaServed": "US",
            "availableLanguage": "EN"
          }],
          "sameAs": ["https://www.youtube.com/channel/UC-rV0wnbUUx8grz1Awtlt-A", "https://www.linkedin.com/company/amzscout", "https://www.facebook.com/amzscoutcrew", "https://twitter.com/amzscout"]
        }
    `}</script>

      <script type="application/ld+json">{`
        {
          "@context": "http://schema.org",
          "@id": "https://amzscout.net/#website",
          "@type": "WebSite",
          "url": "https://amzscout.net",
          "name": "AMZScout"
        }
    `}</script>
      {page === "web-app" ? (
        <script type="application/ld+json">
          {`
            {
              "@context": "http://www.schema.org",
              "@type": "product",
              "brand": "AMZScout",
              "name": "Web App",
              "image": "${ogImg}",
              "description": "Brainstorm your next profitable FBA product idea. Spy on your competition and reveal their weak spots. Discover best keywords for Amazon SEO and PPC. All in one app.",
              "aggregateRating": {
                "@type": "aggregateRating",
                "ratingValue": "4.7",
                "reviewCount": "94"
              }
            }`}
        </script>
      ) : null}
      {page === "stock-stats" ? (
        <script type="application/ld+json">
          {`
            { 
              "@context" : "http://schema.org", 
              "@type" : "SoftwareApplication", 
              "name" : "AMZScout Stock Stats", 
              "image" : "${ogImg}", 
              "url" : "https://amzscout.net/stock-stats/", 
              "publisher" : { "@type" : "Organization", "name" : "AMZScout" }, 
              "applicationCategory" : "Productivity", 
              "downloadUrl" : "https://chrome.google.com/webstore/detail/liobflkelkokkacdemhmgkbpefgaekkm", 
              "screenshot" : "${StockPic}", 
              "review" : { "@type" : "Review", "author" : { "@type" : "Person", "name" : "Paul" }, 
              "datePublished" : "2019-05-23", 
              "reviewRating" : { "@type" : "Rating", "ratingValue" : "5", "bestRating" : "5", "worstRating" : "0" }, 
              "reviewBody" : "I use AMZScout Extension just for a few weeks, but I absolutely like it. It is reliable (because their data is accurate) and much more useful then other similar tools. Besides they often add unique features that none of other tools have." }
              },
            {
              "@context": "http://www.schema.org",
              "@type": "product",
              "brand": "AMZScout",
              "name": "Web App",
              "image": "${ogImg}",
              "description": "Brainstorm your next profitable FBA product idea. Spy on your competition and reveal their weak spots. Discover best keywords for Amazon SEO and PPC. All in one app.",
              "aggregateRating": {
                "@type": "aggregateRating",
                "ratingValue": "4.7",
                "reviewCount": "94"
              }
            }`}
        </script>
      ) : null}
      {page === "keyword-tracker" ? (
        <script type="application/ld+json">
          {`
              {
              "@context": "https://schema.org/", 
              "@type": "Product", 
              "name": "Keyword Tracker", 
              "image": "/img/new/logo.png", 
              "description": "Monitor the keyword ranking positions in Amazon search results for your products and your competitors’ using just the ASIN number. Try for free", "brand": "AMZScout", "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "bestRating": "5", "worstRating": "1", "reviewCount": "47" } }
            `}
        </script>
      ) : null}

      {page === "courses-page" ? (
        <script type="application/ld+json">{`
            { "@context": "http://schema.org", "@id": "https://amzscout.net/#organization", "@type": "Organization", "name": "AMZScout", "url": "https://amzscout.net", "logo": "/img/new/logo.png", "contactPoint": [ { "@type": "ContactPoint", "telephone": "+1-303-800-545", "contactType": "sales", "areaServed": "US" }, { "@type": "ContactPoint", "telephone": "+1-908-428-4921", "contactType": "technical support", "areaServed": "US", "availableLanguage": "EN" } ], "sameAs": [ "https://www.youtube.com/channel/UC-rV0wnbUUx8grz1Awtlt-A", "https://www.linkedin.com/company/amzscout", "https://www.facebook.com/amzscoutcrew", "https://twitter.com/amzscout" ] }
          `}</script>
      ) : null}
      {trustpilotWidget ? (
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        ></script>
      ) : null}
      <script type="application/ld+json">{`
      {
        "@context": "http://schema.org",
        "@id": "https://amzscout.net/#webpage",
        "@type": "WebPage",
        "url": "https://amzscout.net",
        "name": "AMZScout"
      }
    `}</script>
    </Helmet>
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  page: PropTypes.string,
  manifest: PropTypes.string,
  ogImg: PropTypes.string,
  bodyClassName: PropTypes.string,
};

export default Seo;
